import React, { Component } from 'react';
import './index.css';
import { Badge, Table } from 'antd';

import { connect } from 'react-redux'
import { ThunkDispatch } from 'redux-thunk'
import { AnyAction } from 'redux'
import { RootState } from '../../../../../core/reducers';
import { Link, RouteComponentProps } from 'react-router-dom';
import { 
    actionExportData,
    actionGetReportListEntryMerchant, 
    actionGetReportListEntryMerchantByStatus
} from '../../../../../core/actions/silizhu/report';
import moment from 'moment'
import SearchForm from './searchForm'
import ExportForm from './exportForm'
import { ExportExaminationReportRequest } from '../../../../../api/sennotech/scanner/v2/examination';
import { withTranslation, WithTranslationProps } from 'react-i18next';
import { Language } from '../../../../../api/sennotech/scanner/v2/type';

interface StateProps {
    orgId: any
    reportList: any
    routeKey: any
}

interface DispatchProps {
    getReportList(data): void
    getReportListByStatus(): void
    exportData(data: ExportExaminationReportRequest): void
}

interface RouteState {
    tag: string
}

type TypeProps = StateProps & RouteComponentProps<RouteState>;

class Index extends Component<TypeProps & DispatchProps & WithTranslationProps> {
    
    Columns;
    constructor(props) {
        super(props);
        this.Columns = [
            {
                title: '测评店员账号',
                render: (record) => {
                    let examiner = record.examiner || {};
                    return <span>{examiner.mobileNumber || examiner.email}</span>
                }
            },
            {
                title: '用户名称',
                dataIndex: ['examinee', 'nickname'],
                key: 'examinee.nickname'
            },
            {
                title: '客户联系方式',
                render: (record) => {
                    let examinee = record.examinee || {};
                    return <span>{examinee.mobileNumber || examinee.email}</span>
                }
            },
            {
                title: '备注',
                dataIndex: ['examinee', 'description'],
                key: 'description',
                render: (text) => {
                    return <span className="list-reportRemark">{text}</span>
                }
            },
            {
                title: '报告状态',
                render: (record) => {
                    if(record.state === 'PROCESSING') {
                        return (
                            <div>
                                <Badge status="processing" /> 处理中
                            </div>
                        )
                    }
                    else if(record.state === 'SUCCESS') {
                        return (
                            <div>
                                <Badge status="success" /> 报告有效
                            </div>
                        )
                    }
                    else if(record.state === 'FAIL') {
                       return (
                        <div>
                            <Badge status="error" /> 数据无效
                        </div>
                       )
                    }
                }
            },
            {
                title: '创建时间',
                dataIndex: 'createTime',
                key: 'createTime',
                render: (text) => {
                    if(text) {
                        let time = (new Date(text)).valueOf();
                        let timeStr = moment(time).format('YYYY-MM-DD HH:mm:ss') 
                        return <span>{text && timeStr}</span>
                    }
                }
            },
            {
                title: '更多',
                render: (record) => {
                    if(record.state === 'SUCCESS') {
                        let id = record.ticket;
                        // let routeKey = this.props.routeKey;
                        // let url = `/${routeKey}/reportList/detail/${id}`;
                        let editableUrl = record.editableUrl;
                        return (
                            <div>
                                {/* <Link to={{ pathname: url, state: 'back', search: "editable=true"}}>查看</Link> */}
                                <a href={`${editableUrl}&exportable=true`} target="_blank">
                                    查看
                                </a>
                            </div>
                        )
                    }
                    return <span></span>
                }
            },
        ];
    }

    state = {
        pageNum: 1,
        pageSize: 10,
        mobileNumber: '',
        nickname: '',
    }

    intId;
    componentDidMount () {
        const { history } = this.props;
        let pageNum = 1;
        let pageSize = 10;
        if(history.action === 'POP') {
            let pageSizeLocal = localStorage.getItem('pageSize');
            let pageNumLocal = localStorage.getItem('pageNum');
            if(pageSizeLocal && pageNumLocal) {
                pageSize = +pageSizeLocal;
                pageNum = +pageNumLocal;
            }
            else {
                localStorage.setItem('pageNum', pageNum.toString());
                localStorage.setItem('pageSize', pageSize.toString());
            }
            this.setState({
                pageSize: pageSize,
                pageNum: pageNum
            })
        }
        else {
            localStorage.setItem('pageNum', pageNum.toString());
            localStorage.setItem('pageSize', pageSize.toString());
        }
        let data = {
            pageNum,
            pageSize,
        }
        this.props.getReportList(data);
        this.intId = setInterval(() => {
            this.props.getReportListByStatus();
        }, 10000);
    }
    
    componentWillUnmount () {
        clearInterval(this.intId);
    }

    onPageChange = (pageNum, pageSize) => {
        const {
            mobileNumber,
            nickname,
        } = this.state;
        let page = {
            pageNum: pageNum,
            pageSize: pageSize,
            mobileNumber,
            nickname,
        };
        this.setState(page);
        this.props.getReportList(page);
        localStorage.setItem('pageNum', pageNum);
        localStorage.setItem('pageSize', pageSize);
    }

    onSearch = (formdata) => {
        const pageSize = this.state.pageSize;
        let data = {
            pageNum: 1,
            pageSize: pageSize,
            ...formdata,
        }
        this.setState(data);
        this.props.getReportList(data);
        localStorage.setItem('pageNum', '1');
        localStorage.setItem('pageSize', pageSize.toString());
    }
    
    onReset = () => {
        const pageSize = this.state.pageSize;
        let data = {
            pageNum: 1,
            pageSize: pageSize,
            mobileNumber: '',
            nickname: '',
        }
        this.setState(data);
        this.props.getReportList(data);
        localStorage.setItem('pageNum', '1');
        localStorage.setItem('pageSize', pageSize.toString());
    }

    onExport = (formdata) => {
        const { orgId, i18n } = this.props;
        this.props.exportData({
            storeId: +orgId,
            startTimestamp: +formdata.exportTime[0].format('x'),
            endTimestamp: +formdata.exportTime[1].format('x'),
            language: i18n?.language === "en" ? Language.EN : Language.ZH
        })
    }

    render () {

        let data = this.props.reportList || {};
        let list  = data.reports || [];
        let total = +(data.totalElements || '0');

        return (
            <div className="reportList-merchant model">
                <h3 className="margin-bottom-12">报告列表</h3>
                <div className="flex-top">
                    <SearchForm 
                        onSearch={this.onSearch}
                        onReset={this.onReset}
                        />
                    {/* <ExportForm onExport={this.onExport} /> */}
                </div>
                <Table 
                    rowKey={(record) => record.ticket}
                    dataSource={list} 
                    columns={this.Columns}
                    pagination={{
                        showSizeChanger: true,
                        total: total,
                        defaultCurrent: this.state.pageNum,
                        current: this.state.pageNum,
                        onChange: this.onPageChange,
                        onShowSizeChange: this.onPageChange,
                        showTotal: total => `总 ${total} 条`
                    }}
                    />
            </div>
        )
    }
}

function mapStateToProps(state: RootState): StateProps {
    return {
        orgId: state.user.orgId,
        reportList: state.silizhuReport.reportList,
        routeKey: state.user.routeKey,
    }
}

function mapDispatchToProps(dispatch: ThunkDispatch<RootState, null, AnyAction>): DispatchProps {
    return {
        getReportList: (data) => {
            dispatch(actionGetReportListEntryMerchant(data))
        },
         getReportListByStatus: () => {
            dispatch(actionGetReportListEntryMerchantByStatus())
        },
        exportData: (data) => {
            dispatch(actionExportData(data))
        }
    }
}

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Index))